module.exports = __webpack_public_path__ + "img/loginCode.99443a89.png";